module.exports = __webpack_public_path__ + "img/11 Animation 2-squashed.7175fe39.jpg";